var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-activity-log", attrs: { id: "formActivityLog" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          attrs: {
            show: _vm.isShowFilterPopover,
            target: "filter-img",
            placement: "bottom",
            container: "formActivityLog"
          },
          on: {
            "update:show": function($event) {
              _vm.isShowFilterPopover = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "filter-popover" },
            [
              _c("j-single-select", {
                staticClass: "m__r--5",
                staticStyle: { width: "200px" },
                attrs: {
                  options: _vm.filterKeyOptions,
                  "error-required": false,
                  placeholder: "Filter By"
                },
                model: {
                  value: _vm.filterKey,
                  callback: function($$v) {
                    _vm.filterKey = $$v
                  },
                  expression: "filterKey"
                }
              }),
              _vm._v(" "),
              _c("j-single-select", {
                staticStyle: { width: "450px" },
                attrs: {
                  "load-options": _vm.loadOptionsUser,
                  "is-async": true,
                  "cache-option": false,
                  "error-required": false,
                  disabled: !_vm.filterKey,
                  "default-options": false,
                  placeholder: "Search"
                },
                model: {
                  value: _vm.filterValue,
                  callback: function($$v) {
                    _vm.filterValue = $$v
                  },
                  expression: "filterValue"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.isLoading ? _c("jSkeletonFormActivityLog") : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.dataLog && _vm.dataLog.length > 0
        ? _c(
            "div",
            { staticClass: "activity-log-container" },
            _vm._l(_vm.dataLog, function(log) {
              return _c(
                "div",
                { key: log.id, staticClass: "activity-log-item" },
                [
                  _c("div", { staticClass: "item-main" }, [
                    _c(
                      "div",
                      { staticClass: "left" },
                      [
                        log.user_info && log.user_info.photo_url
                          ? _c("img", {
                              staticClass: "photo-label",
                              attrs: { src: log.user_info.photo_url }
                            })
                          : _c("img", {
                              staticClass: "photo-label",
                              attrs: { src: require("@/assets/logo/user1.png") }
                            }),
                        _vm._v(" "),
                        _c("span", { staticClass: "name-label" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                log.user_info ? log.user_info.full_name : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "action-tag",
                            class: {
                              purple: log.action === "PURGING_DATA",
                              blue: log.action === "ADD_COLUMN",
                              red: log.action === "DELETE_COLUMN",
                              green: log.action === "ARCHIVE_DATA"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  log.action
                                    ? log.action.split("_").join(" ")
                                    : ""
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        (log.action === "ARCHIVE_DATA" ||
                          log.action === "PURGE_DATA") &&
                        log.additional_info &&
                        log.additional_info.last_data
                          ? _c("span", { staticClass: "date-tag" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm
                                      .$moment(log.additional_info.last_data)
                                      .format("DD MMMM YYYY")
                                  ) +
                                  "\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        log.columns
                          ? _vm._l(log.columns, function(column, i) {
                              return _c(
                                "span",
                                { key: i, staticClass: "date-tag" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(column) +
                                      "\n            "
                                  )
                                ]
                              )
                            })
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    log.timestamp
                      ? _c("span", { staticClass: "date-label" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm
                                  .$moment(log.timestamp)
                                  .format("DD MMMM YYYY HH:mm:ss")
                              ) +
                              "\n        "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  log.remarks
                    ? [
                        _c(
                          "div",
                          { staticClass: "item-remarks" },
                          [
                            _c("p", [_vm._v("Remarks")]),
                            _vm._v(" "),
                            _c("j-textarea", {
                              attrs: { "error-required": false, disabled: "" },
                              model: {
                                value: log.remarks,
                                callback: function($$v) {
                                  _vm.$set(log, "remarks", $$v)
                                },
                                expression: "log.remarks"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.useConfigArchivePurge &&
                  log.action === "ARCHIVE_DATA" &&
                  !_vm.isLoadingArchiveInfo
                    ? _vm._l(_vm.dataArchive, function(item) {
                        return _c("div", { key: item.id }, [
                          log.additional_info &&
                          log.additional_info.archive_id &&
                          log.additional_info.archive_id === item.archiveId &&
                          item.archive_record
                            ? _c("div", { staticClass: "item-additional" }, [
                                _c("div", { staticClass: "left" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/icon/file-csv.svg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-column" },
                                    [
                                      _c("div", { staticClass: "file-name" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.archive_record.file_name
                                            ) +
                                            "\n                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      item.archive_record.status === "success"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "file-download",
                                              on: {
                                                click: function($event) {
                                                  _vm.getUrlDownloadFile(
                                                    item.archive_record.file_id,
                                                    item.archive_record
                                                      .file_name
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Download\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "status",
                                    class: {
                                      success:
                                        item.archive_record.status ===
                                        "success",
                                      process:
                                        item.archive_record.status === "process"
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "circle" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(item.archive_record.status))
                                    ])
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          log.additional_info &&
                          log.additional_info.archive_id &&
                          log.additional_info.archive_id === item.archiveId &&
                          item.archive_log_record
                            ? _c("div", { staticClass: "item-additional" }, [
                                _c("div", { staticClass: "left" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/icon/file-csv.svg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-column" },
                                    [
                                      _c("div", { staticClass: "file-name" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.archive_log_record.file_name
                                            ) +
                                            "\n                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      item.archive_log_record.status ===
                                      "success"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "file-download",
                                              on: {
                                                click: function($event) {
                                                  _vm.getUrlDownloadFile(
                                                    item.archive_log_record
                                                      .file_id,
                                                    item.archive_log_record
                                                      .file_name
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Download\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "status",
                                    class: {
                                      success:
                                        item.archive_log_record.status ===
                                        "success",
                                      process:
                                        item.archive_log_record.status ===
                                        "process"
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "circle" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(item.archive_log_record.status)
                                      )
                                    ])
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  log.action === "ARCHIVE_DATA" && _vm.isLoadingArchiveInfo
                    ? _c("jSkeletonArchiveFileInfo")
                    : _vm._e()
                ],
                2
              )
            })
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.dataLog && _vm.dataLog.length === 0
        ? _c("div", { staticClass: "activity-log-container" }, [
            _c("div", { staticClass: "activity-log-item text-center" }, [
              _vm._v("\n      No matching records\n    ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "activity-log-pagination" }, [
        _c(
          "div",
          {
            staticClass: "previous",
            class: { disabled: _vm.isLoading || _vm.pageCount === 1 },
            on: { click: _vm.handlePreviousPage }
          },
          [_c("i", { staticClass: "fa fa-chevron-left" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "next",
            class: {
              disabled:
                _vm.isLoading || (_vm.dataLog && _vm.dataLog.length < 10)
            },
            on: { click: _vm.handleNextPage }
          },
          [_c("i", { staticClass: "fa fa-chevron-right" })]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "activity-log-filter" }, [
      _c("img", {
        attrs: { id: "filter-img", src: require("@/assets/icon/filter.svg") }
      }),
      _vm._v("\n    Filter\n  ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cdc847c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cdc847c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jFormActivityLog.vue
// module id = null
// module chunks = 